export default {"src":"/_next/static/media/gradient-link-arrow.81cb22a5.svg","height":14,"width":14,"blurWidth":0,"blurHeight":0};